<template>
  <p>Successfully authed</p>
</template>
<script setup>
import {onMounted} from "vue";

onMounted(async () => {
  console.log('Hit auth0 callback');
})
</script>